import IconContainer from '@/components/IconContainer'

export default function IconSortArrowUp(props) {
  return (
    <IconContainer
      {...props}
      width="6"
      height="3"
      ariaLabel="Sort Arrow Up Icon"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M3 0L6 3L0 3L3 0Z" />
    </IconContainer>
  )
}
